module.exports = __webpack_public_path__ + "img/logo-b.b124985b.png";